
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import InvoiceCreationGuard from '@/components/invoices/InvoiceCreationGuard';
import EstimateSelector from '@/components/invoices/components/EstimateSelector';
import StandaloneInvoiceForm from '@/components/invoices/standalone/StandaloneInvoiceForm';

const CreateInvoicePage = () => {
  const [searchParams] = useSearchParams();
  const estimateId = searchParams.get('estimate_id');
  const customerId = searchParams.get('customer');
  const mode = searchParams.get('mode');

  // Standalone mode (no estimate)
  if (mode === 'standalone') {
    return (
      <div className="pb-6">
        <StandaloneInvoiceForm preselectedCustomerId={customerId || undefined} />
      </div>
    );
  }

  // If we have an estimate, use the existing estimate-based flow
  if (estimateId) {
    return (
      <div className="pb-6">
        <InvoiceCreationGuard estimateId={estimateId} />
      </div>
    );
  }

  // If we have a customer but no estimate, show estimate selector with standalone option
  if (customerId) {
    return (
      <div className="pb-6">
        <EstimateSelector customerId={customerId} />
      </div>
    );
  }

  // No params — standalone form with customer picker
  return (
    <div className="pb-6">
      <StandaloneInvoiceForm />
    </div>
  );
};

export default CreateInvoicePage;
